import { render, staticRenderFns } from "./emba-overview.vue?vue&type=template&id=1479cdc1&scoped=true"
import script from "./emba-overview.vue?vue&type=script&lang=ts"
export * from "./emba-overview.vue?vue&type=script&lang=ts"
import style0 from "./emba-overview.vue?vue&type=style&index=0&id=1479cdc1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479cdc1",
  null
  
)

export default component.exports